import type { CoreStores } from '@tinycld/core/lib/pocketbase'
import type { Schema } from '@tinycld/core/types/pbSchema'
import type { createCollection } from 'pbtsdb/core'
import { BasicIndex } from 'pbtsdb/core'
import type { TextSchema } from './types'

// Replace (not intersect) the generated entries for text's own collections —
// a plain intersection would merge each overlapping entry field-wise, letting
// a generated `any` absorb any typed override (see drive's collections.ts).
type MergedSchema = Omit<Schema, keyof TextSchema> & TextSchema

// Every collection syncs on demand and subscribes per query (pbtsdb 0.10):
// only the rows a live query asks for enter the store, and realtime covers
// exactly those rows. The server emits a delete to a subscription a row
// leaves, so a filtered view stays correct across updates.
const onDemand = { syncMode: 'on-demand', realtime: 'query' } as const

export function registerCollections(
    newCollection: ReturnType<typeof createCollection<MergedSchema>>,
    coreStores: CoreStores
) {
    // Hoisted rather than inlined: an inline `collectionOptions` object literal
    // defeats inference of `alwaysFetchRelations` against `relations` in pbtsdb,
    // typing every expand path as `never`. See core/lib/pocketbase.ts, which
    // hoists the same shape as `indexing`.
    const indexing = {
        autoIndex: 'eager' as const,
        defaultIndexType: BasicIndex,
    }

    const text_comments = newCollection('text_comments', {
        omitOnInsert: ['created', 'updated'] as const,
        ...onDemand,
        relations: { author: coreStores.users },
        collectionOptions: indexing,
    })
    return { text_comments }
}
